<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header" row wrap align-content-center justify-center>
        <v-flex xs12>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-cog</v-icon>
              Suporte
            </h1>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 class="section-box">
      <h3 class="subsection-title text-xs-left text-normal text-lower">
        <div class="mx-4 my-2">
          Ticket #{{ ticket.number }} - {{ ticket.message }}
        </div>
      </h3>

      <div class="mx-3 my-3">
        <v-layout align-content-start row wrap justify-start>
          <v-flex xs12 md9>
            <ticket-messages :messages="messages"></ticket-messages>
          </v-flex>
          <v-flex xs12 md3>
            <ticket-sidebar :ticket="ticket"></ticket-sidebar>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import AdminTicketShowMessages from '@/components/admin/support/AdminTicketShowMessages'
import AdminTicketShowSidebar from '@/components/admin/support/AdminTicketShowSidebar'

export default {
  data: () => ({
    ticket: {},
    messages: []
  }),

  methods: {
    loadTicket () {
      EventBus.$emit('appLoading', true)

      // eslint-disable-next-line
      axios.get(API.userTickets + '/' + this.$route.params.id).then(response => {
        this.ticket = response.data.ticket
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar os tickets',
          color: 'error'
        })
        EventBus.$emit('appLoading', false)
      })
    },

    loadAnswers () {
      // eslint-disable-next-line
      axios.get(API.userTicketsAnswers + '/tickets/' + this.$route.params.id).then(response => {
        this.messages = response.data.answers
        EventBus.$emit('appLoading', false)

        if (!response.data.answers.length) {
          const message = {
            user: this.ticket.user,
            comment: this.ticket.message
          }

          this.sendMessage(message)
        }
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as mensagens',
          color: 'error'
        })
        EventBus.$emit('appLoading', false)
      })
    },

    sendMessage (message) {
      EventBus.$emit('appLoading', true)

      // eslint-disable-next-line
      axios.post(API.userTicketsAnswers + '/tickets/' + this.$route.params.id, message).then(response => {
        EventBus.$emit('appLoading', false)
        EventBus.$emit('loadAnswers')
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
      })
    },

    updateTicket () {
      // eslint-disable-next-line
      axios.put(`${API.userTickets}/${this.$route.params.id}`, this.ticket)
    }
  },

  beforeDestroy () {
    EventBus.$off('loadTicket')
    EventBus.$off('loadAnswers')
    EventBus.$off('updateTicket')
  },

  created () {
    this.loadTicket()
    this.loadAnswers()

    EventBus.$on('loadTicket', data => {
      this.loadTicket()
    })

    EventBus.$on('loadAnswers', data => {
      this.loadAnswers()
    })

    EventBus.$on('updateTicket', data => {
      this.updateTicket()
    })
  },

  components: {
    'ticket-messages': AdminTicketShowMessages,
    'ticket-sidebar': AdminTicketShowSidebar
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/support/AdminTicketShow.vue